export default {
  subjectData: state => state.subjectData,
  subjectGrade: state => state.subjectGrade,
  subjectToLabel: state => state.subjectToLabel,
  filterSubject (state) {
    return state.subjectData.slice(7)
  },
  filterGrade (state) {
    return state.subjectGrade.slice(7)
  }
}
